module.exports = __webpack_public_path__ + "img/slp_eth_usdc.917265e8.svg";